<template>
  <div style="z-index: 100">
    <v-app-bar v-if="driverUser" color="white" app>
      <v-app-bar-nav-icon v-if="!isSessionComponent" @mouseenter="drawer = true" @click="drawer = !drawer">
      </v-app-bar-nav-icon>

      <v-toolbar-title>
        <v-img v-if="mode === 'transport_disposal'" max-height="300" max-width="300" contain
          :src="require(`@/assets/images/DXEstation_SS_logo_yoko_RGB.png`)" />
        <v-img v-else-if="mode === 'disposal'" max-height="300" max-width="300" contain
          :src="require(`@/assets/images/DXEstation_Shobun_logo_yoko_RGB.png`)" />
        <v-img v-else max-height="300" max-width="300" contain
          :src="require(`@/assets/images/DXEstation_S_logo_yoko_RGB.png`)" />
      </v-toolbar-title>

      <v-spacer />

      <v-btn v-if="me" icon x-large shaped link :href="me.tenant.manual_url" target="manual">
        <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>
      &nbsp;
      <v-badge v-if="!isSessionComponent && unread_count > 0" :content="unread_count" :value="unread_count" overlap
        color="red">
        <v-btn icon small @click="importantNotificationClickEvent">
          <v-icon large>
            mdi-bell-outline
          </v-icon>
        </v-btn>
      </v-badge>
      &emsp;
      <v-list-item-avatar v-if="me && !isSessionComponent" color="primary">
        <div style="height: 60px">
          <v-img :src="me.avatar_url" max-height="60" max-width="60" contain />
        </div>
        <span v-if="!me.avatar_url" class="primary white--text">
          {{ me.name.slice(0, 2) }}
        </span>
      </v-list-item-avatar>

      <div v-if="!$vuetify.breakpoint.smAndDown && me && !isSessionComponent">
        &nbsp;{{ me.name }}<small>({{ tenantName }})</small>&nbsp;
      </div>
      <v-menu v-if="!isSessionComponent" bottom offset-y rounded style="z-index: 200">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-if="isSuperSupportUser && me && me.can_change_tenant"
            link
            @click="showChangeTenantDialogClickEvent">
            <v-list-item-title>
              支店/営業所切替
            </v-list-item-title>
          </v-list-item>
          <v-list-item link @click="showChangePasswordDialogClickEvent">
            <v-list-item-title>
              パスワード変更
            </v-list-item-title>
          </v-list-item>
          <v-list-item link @click="logoutButtonClickEvent">
            <v-list-item-title>
              ログアウト
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer
      v-if="!isSessionComponent"
      v-model="drawer"
      :style="drawerStyle"
      color="primary"
      dark
      fixed
      temporary
      width="400"
    >
      <div style="height: 100%;">
      <v-spacer />
      <v-list
        :shaped="true"
        expand
      >
        <v-list-item-group
          v-model="selectedValue"
          mandatory
        >
        <template v-for="mainMenu in menus">
          <v-divider
            v-if="mainMenu.type === 'stripped'"
            :key="`divider-${mainMenu.key}`"
          />
          <v-list-item
            v-if="!mainMenu.menus && mainMenu.enabled !== false"
            :key="mainMenu.key"
            :value="mainMenu.key"
            active-class="sideMenuSelected"
            @click="listClickEvent(mainMenu)"
          >
            <v-list-item-icon>
              <v-icon>{{ mainMenu.icon }}</v-icon>
              <v-badge
                v-if="unread_count > 0 && mainMenu.badge"
                :content="unread_count"
                :value="unread_count"
                color="red"
                overlap
              />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ mainMenu.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-group
            v-if="mainMenu.menus && mainMenu.enabled"
            :key="mainMenu.key"
            :prepend-icon="mainMenu.icon"
            :value="mainMenu.opened"
            color="white"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{ mainMenu.text }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <template v-for="list in mainMenu.menus">
              <v-list-item
                v-if="list.enabled"
                :key="list.key"
                :value="list.key"
                active-class="sideMenuSelected"
                link
                sub-group
                @click="listClickEvent(list)"
              >
                <v-list-item-title>{{ list.text }}</v-list-item-title>
              </v-list-item>
            </template>
          </v-list-group>
        </template>
        </v-list-item-group>
      </v-list>
      </div>
    </v-navigation-drawer>
    <change-password-dialog
      :enable-dialog="enableChangePasswordDialog"
      @closeEvent="closeChangePasswordDialog"
      @registerEvent="changePasswordCallback"
    />
    <change-tenant-dialog
      :enable-dialog="enableChangeTenantDialog"
      @closeEvent="closeChangeTenantDialog"
      @registerEvent="changeTenantCallback"
    />
  </div>
</template>

<script>

import { mapActions, mapGetters, mapState } from 'vuex'
import ChangePasswordDialog from './ChangePasswordDialog'
import ChangeTenantDialog from './ChangeTenantDialog'
import '@/assets/icomoon/style.css'

export default {
  name: 'HeaderNav',
  components: {
    ChangePasswordDialog,
    ChangeTenantDialog
  },
  mixins: [
  ],
  data() {
    return {
      selectedValue: 0,
      selectedSubValue: null,
      expand_locations: false,
      enableChangePasswordDialog: false,
      enableChangeTenantDialog: false,
      normalizedFrequencyMinutes: 1,
      notificationUnreadTimer: null,
      drawer: false,
      /**
       * @param {Object} me - ログイン者情報
       * @param {string} me.name - ログイン者氏名
       * @param {string} me.avatar_url - ログイン者顔写真
       * @param {boolean} me.can_change_tenant - テナント変更権限
       */
      me: null,
      menus: null,
    }
  },
  computed: {
    /**
     * @param {Object} driverUser - ログインユーザ
     */
    ...mapGetters('DriverAuthentication', [
      'driverUser',
      'tenantId',
      'tenantName',
      'isSuperSupportUser'
    ]),
    ...mapState('DriverNotificationAlert', {
      unread_count: 'unread_count'
    }),
    ...mapState('DriverTenantConfiguration', {
      isAllocate: 'use_allocate',
      isEcContract: 'use_ec_contract',
      mode: 'mode',
      isBilling: 'use_billing',
      isBillingWithFreee: 'use_freee_claim',
      isJwMode: 'use_jw_mode',
      isJwnetTransfer: 'use_jwnet_transfer',
      isEcContractSinglePlan: 'use_ec_contract_single_plan',
    }),
    ...mapState("DriverAppVariable", {
      savedMenuKey: "menu_key"
    }),
    isSessionComponent() {
      let components = ['DriverSessions', 'DriverInitialPasswordEdit', 'DriverInvitations']
      return components.includes(this.$route.name)
    },
    /**
     * ヘッダーの高さに応じてメニューの位置を調整
     */
    drawerStyle() {
      // モバイル (xs, sm) では 56px、それ以外は 64px
      const headerHeight = this.$vuetify.breakpoint.smAndDown ? 56 : 64
      return {
        top: `${headerHeight}px !important`,
        height: `calc(100% - ${headerHeight}px) !important`
      }
    }
  },
  watch: {
    driverUser(newValue) {
      if (newValue) {
        this.findMe()
        clearInterval(this.notificationUnreadTimer)
        this.searchNotificationUnreadCount()
      }
    },
    tenantName(newValue) {
      if (newValue) {
        this.findMe()
        clearInterval(this.notificationUnreadTimer)
        this.searchNotificationUnreadCount()
      }
    },
    $route(to, from) {
      this.openMenu()
    },
    isAllocate(newValue) {
      this.menuLoad()
    },
    isEcContract(newValue) {
      this.menuLoad()
    },
  },
  created() {
    if ((this.driverUser) && (!this.isSessionComponent)) {
      this.findMe()
    }

    setInterval(this.searchNotificationUnreadCount, 1000 * 60 * this.normalizedFrequencyMinutes);

    this.menuLoad()
  },
  methods: {
    ...mapActions('DriverAuthentication', {
      signOut: 'signOutDriver'
    }),
    ...mapActions('DriverMe', {
      fetchMe: 'show',
    }),
    ...mapActions('DriveContractAuthorize', {
      createAuthorizationCode: 'create',
    }),
    ...mapActions('DriverNotificationAlert', {
      fetchUnreadCount: 'fetchUnreadCount',
    }),
    ...mapActions("DriverAppVariable", {
      saveMenuKey: 'saveMenuKey',
    }),
    /**
     * メニュー クリックイベント
     */
    listClickEvent(item) {
      if (item.name === 'EcContract') {
        if (this.isEcContract) {
          this.bridgeToEcContract()
        } else {
          this.bridgeToGradeUp()
        }
      } else {
        this.saveMenuKey({ menuKey: item.key })
        this.$router.push({ name: item.name, params: item.params, query: item?.query }, () => { })
      }
    },

    /**
     * パスワード変更クリックイベント
     */
    showChangePasswordDialogClickEvent() {
      this.enableChangePasswordDialog = true
    },

    searchNotificationUnreadCount() {
      if (this.driverUser) {
        this.fetchUnreadCount()
      }
    },
    /**
     * サブメニュー選択時の表示制御
     */
    async openMenu() {
      let willSet = false
      for (const menu of this.menus) {
        if (menu.type && menu.type === 'stripped') {
          continue;
        }

        if (menu.key === this.savedMenuKey) {
          this.selectedValue = menu.key
          break
        }

        const initialMenuKey = menu.key.split('_')[0]
        const selectableInitialMenuKey = this.savedMenuKey.split('_')[0]

        // サブメニューあり
        if (menu.menus) {
          // 一致
          if (initialMenuKey === selectableInitialMenuKey) {
            menu.opened = true
            for (const subMenu of menu.menus) {
              if (this.savedMenuKey === subMenu.key) {
                subMenu.active = true
                this.selectedValue = subMenu.key
                willSet = true
                break
              }
            }
            if (willSet) {
              break
            }
          }
        }
      }
    },
    /**
     * ログイン者情報を取得
     */
    findMe() {
      this.fetchMe().then((content) => {
        this.me = content
        this.menuLoad()
      })
    },

    /**
     * パスワード変更 閉じるクリクイベント
     */
    changePasswordCallback() {
      this.closeChangePasswordDialog()
    },
    /**
     * パスワード変更ダイアログ 閉じる
     */
    closeChangePasswordDialog() {
      this.enableChangePasswordDialog = false
    },
    /**
     * テナント切替クリックイベント
     */
    showChangeTenantDialogClickEvent() {
      this.enableChangeTenantDialog = true
    },
    /**
     * テナント切替 閉じるクリクイベント
     */
    changeTenantCallback() {
      this.closeChangeTenantDialog()
    },
    /**
     * テナント切替ダイアログ 閉じる
     */
    closeChangeTenantDialog() {
      this.enableChangeTenantDialog = false
    },
    /**
     * ログアウトクリックイベント
     */
    logoutButtonClickEvent() {
      this.signOut().then(() => {
        this.$router.replace({ name: 'DriverSessions' }, () => { })
      })
    },
    importantNotificationClickEvent() {
      this.$router.replace({ name: 'DriverNotifications' }, () => { })
    },
    /**
     * メニューロード
     * 第一階層は必ず「*_0」であること。
     * 第ニ階層のアンダーバーの前の数値は必ず親と一致していること
     */
    menuLoad() {
      /**
       * 1_0: ダッシュボード
       * 2_0: 受発注
       * 8_0: 処分場受入
       * 300_0: 配車計画
       * 301_0: ドライバースケジュール
       * 4_0: 売上請求管理
       * 5_0: マニフェスト管理
       * 11_0: JWNETデータ取込
       * 9_0: 行政報告データ出力
       * 6_0: お知らせ
       * 10_0: 電子契約
       * 7_0: マスタ設定
       * 12_0: 再資源化マスタ設定
       */
      this.menus = [
        { text: 'ダッシュボード', icon: 'icon-dashboard', name: 'DriverDashboard', key: '1_0', params: {}, enabled: !this.isJwMode, active: false },
        {
          text: '受発注',
          icon: 'mdi-format-list-text',
          key: '2_0',
          enabled: true,
          active: false,
          opened: false,
          menus: [
            { text: '受注（回収・持込・積替・搬入）', name: 'DriverOrderAccepts', key: '2_1', params: { resetCondition: true }, enabled: !this.isJwMode && (this.mode === 'transport' || this.mode === 'transport_disposal'), active: false },
            { text: '受注', name: 'DriverOrderAccepts', key: '2_2', params: { resetCondition: true }, enabled: this.isJwMode || this.mode === 'disposal', active: false },
            { text: '発注（積替・搬入）', name: 'DriverOrderRequests', key: '2_3', params: { resetCondition: true }, enabled: (this.mode === 'transport' || this.mode === 'transport_disposal'), active: false },
          ]
        },
        { text: '処分場受入', icon: 'mdi-home-import-outline', name: 'DriverAcceptances', key: '8_0', params: { resetCondition: true }, enabled: (this.mode === 'transport_disposal' || this.mode === 'disposal') && !this.isJwMode, active: false },
        { text: '配車計画', icon: 'mdi-truck-outline', name: 'DriverAllocations', key: '300_0', params: {}, enabled: this.isAllocate && (this.mode === 'transport' || this.mode === 'transport_disposal'), active: false },
        { text: 'ドライバースケジュール', icon: 'mdi-store-clock-outline', name: 'DriverSchedules', key: '301_0', params: {}, enabled: !this.isAllocate && !this.isJwMode && (this.mode === 'transport' || this.mode === 'transport_disposal'), active: false },
        {
          text: '売上請求管理',
          icon: 'mdi-point-of-sale',
          key: '4_0',
          enabled: this.isBilling,
          active: false,
          opened: false,
          menus: [
            { text: '売上管理', name: 'DriverSalesTransactions', key: '4_1', params: { resetCondition: true }, enabled: this.isBilling, active: false },
            { text: '請求管理', name: 'DriverSalesRequests', key: '4_2', params: { resetCondition: true }, enabled: this.isBilling, active: false },
            { text: 'freee請求連携', name: 'DriverSalesFreeeTransactions', key: '4_3', params: { resetCondition: true }, enabled: this.isBillingWithFreee, active: false },
          ],
        },
        {
          text: 'マニフェスト管理',
          icon: 'mdi-list-status',
          key: '5_0',
          enabled: true,
          active: false,
          opened: false,
          menus: [
            { text: 'マニフェスト一覧', name: 'DriverManifestManagements', key: '5_1', params: { resetCondition: true }, enabled: true, active: false },
            { text: '１次２次紐付け', name: 'DriverManifestLinkages', key: '5_2', params: { resetCondition: true }, enabled: this.mode === 'transport_disposal' || this.mode === 'disposal', active: false },
          ],
        },
        { text: 'JWNETデータ取込', icon: 'mdi-application-import', name: 'DriverTransfers', key: '11_0', params: { resetCondition: true }, enabled: this.isJwnetTransfer, active: false },
        {
          text: '行政報告データ出力',
          icon: 'mdi-database-arrow-down',
          key: '9_0',
          enabled: true,
          active: false,
          opened: false,
          menus: [
            { text: '交付等状況報告書', name: 'DriverReportIssuanceStatuses', key: '9_1', params: { resetCondition: true }, enabled: true, active: false },
            { text: '実績報告書用データ', name: 'DriverReportGovernments', key: '9_2', params: { resetCondition: true }, enabled: true, active: false },
            { text: 'マニフェスト集計', name: 'DriverReportManifests', key: '9_3', params: { resetCondition: true }, enabled: true, active: false },
          ],
        },
        { text: 'お知らせ', icon: 'mdi-bell-outline', name: 'DriverNotifications', key: '6_0', badge: true, params: { resetCondition: true }, enabled: true, active: false },
        {
          text: '電子契約',
          icon: 'mdi-file-sign',
          name: 'EcContract',
          key: '10_0',
          params: {},
          enabled: !this.isJwMode,
          active: false
        },
        { text: '', icon: '', key: 'stripped_1', type: 'stripped', enabled: false, active: false },
        {
          text: 'マスタ設定',
          icon: 'icon-settings',
          key: '7_0',
          enabled: true,
          active: false,
          opened: false,
          menus: [
            { text: '契約情報', name: 'DriverMasterTenant', key: '7_1', params: {}, enabled: true, active: false },
            { text: 'ユーザ', name: 'DriverMasterUsers', key: '7_2', params: { resetCondition: true, resetPagination: true }, enabled: true, active: false },
            { text: '排出事業者', name: 'DriverMasterEmissions', key: '7_3', params: { resetCondition: true }, enabled: true, active: false },
            { text: '請求先', name: 'DriverMasterBillingAddresses', key: '7_4', params: { resetCondition: true, resetPagination: true }, enabled: this.isBilling, active: false },
            { text: '収集運搬業者', name: 'DriverMasterTransports', key: '7_5', params: { resetCondition: true }, enabled: true, active: false },
            { text: '処分業者', name: 'DriverMasterDisposers', key: '7_6', params: { resetCondition: true }, enabled: true, active: false },
            { text: '処分事業場(再資源)', name: 'DriverMasterFinalDisposalSites', key: '7_7', params: { resetCondition: true }, enabled: true, active: false },
            { text: '公共積替', name: 'DriverMasterPublicPlaces', key: '7_8', params: { resetPagination: true }, enabled: true, active: false },
            { text: '報告不要業者', name: 'DriverMasterNonReportingTraders', key: '7_15', params: { resetCondition: true }, enabled: true, active: false },
            { text: '一般廃棄物処分業者', name: 'DriverMasterGeneralWasteDisposals', key: '7_20', params: { resetCondition: true }, enabled: true, active: false },
            { text: 'JWNET未加入業者', name: 'DriverMasterNonSubscribeTraders', key: '7_17', params: { resetCondition: true }, enabled: true, active: false },
            { text: 'JWNET取扱品目', name: 'DriverMasterItems', key: '7_9', params: { resetCondition: true }, enabled: true, active: false },
            { text: '一般廃棄物品目', name: 'DriverMasterGeneralItems', key: '7_19', params: { resetCondition: true }, enabled: true, active: false },
            { text: 'ルート', name: 'DriverMasterTransportRoutes', key: '7_10', params: { resetCondition: true }, enabled: true, active: false },
            { text: '車両', name: 'DriverMasterVehicles', key: '7_11', params: { resetCondition: true }, enabled: true, active: false },
            { text: '売上品目単位', name: 'DriverMasterSalesItemUnits', key: '7_12', params: { resetCondition: true }, enabled: this.isBilling, active: false },
            { text: '売上品目単価', name: 'DriverMasterSalesItemPrices', key: '7_13', params: { resetCondition: true }, enabled: this.isBilling },
            { text: '取引先品目単価', name: 'DriverMasterEmissionSalesItemPrices', key: '7_14', params: { resetCondition: true }, enabled: false, active: false },
            { text: '行政報告換算係数', name: 'DriverMasterConversionFactorDetails', key: '7_16', params: { resetCondition: true }, enabled: true, active: false },
            { text: 'カスタム表示ラベル', name: 'DriverMasterCustomLabel', key: '7_18', params: {}, enabled: this.isJwMode }
          ]
        },
        {
          text: '再資源化マスタ設定',
          icon: 'mdi-store-cog-outline',
          key: '12_0',
          enabled: (this.mode === 'transport_disposal' || this.mode === 'disposal'),
          active: false,
          opened: false,
          menus: [
            { text: '処分方法', name: 'DriverMasterRecycleDisposalMethods', key: '12_1', params: { resetCondition: true }, enabled: true, active: false },
            { text: '処理後物', name: 'DriverMasterRecycleDisposedItems', key: '12_2', params: {}, enabled: true, active: false },
            { text: '再資源化等パターン', name: 'DriverMasterRecycleDisposalPatterns', key: '12_3', params: { resetCondition: true }, enabled: true, active: false },
            // { text: '処分場処理方法', name: 'DriverMasterRecycleDisposalPatterns', key: '12_11', params: { resetCondition: true, flowMode: false }, enabled: true, active: false },
            // { text: '処理フロー', name: 'DriverMasterRecycleDisposalFlows', key: '12_12', params: { resetCondition: true, flowMode: true }, enabled: true, active: false },
            { text: '再資源化換算係数', name: 'DriverMasterRecycleConversionFactorDetails', key: '12_4', params: {}, enabled: true, active: false },
          ]
        }
      ]
      this.openMenu()
    },

    /**
     * 電子契約 起動
     */
    bridgeToEcContract() {
      this.createAuthorizationCode().then((content) => {
        let authorizationCode = content.code
        window.open(process.env.VUE_APP_EC_CONTRACT_BRIDGE_URL + authorizationCode + '&id=' + this.tenantId, "_blank")
      })
    },
    /**
     * グレードアップページへの誘導 起動
     */
    bridgeToGradeUp() {
      this.createAuthorizationCode().then((content) => {
        let authorizationCode = content.code
        window.open(process.env.VUE_APP_GRADEUP_GUIDE_URL, "_blank")
      })
    },
  }
}

</script>

<style lang="scss">
.v-badge__badge {
  line-height: 0.7 !important;

  &.red {
    height: 17px;
    min-width: 17px;
  }
}
</style>
